
    import Vue from "vue";

    const END_POINT = "/staffRequirementSubmission";

    const getStaffRequirementSubmission = id => Vue.axios.get(END_POINT + "/" + id);

    const getAllStaffRequirementSubmissions = data => Vue.axios.get(END_POINT, {params: data});

    const createStaffRequirementSubmission = staffRequirementSubmission => Vue.axios.post(END_POINT,  staffRequirementSubmission );

    const createAllStaffRequirementSubmissions = StaffRequirementSubmissions => Vue.axios.post(END_POINT + "/all",  StaffRequirementSubmissions );

    const updateStaffRequirementSubmission = staffRequirementSubmission => Vue.axios.put(END_POINT  + "/" + staffRequirementSubmission.id,  staffRequirementSubmission );

    const deleteStaffRequirementSubmission = id => Vue.axios.delete(END_POINT  + "/" + id);

    export {
      getStaffRequirementSubmission,
      getAllStaffRequirementSubmissions,
      createStaffRequirementSubmission,
      createAllStaffRequirementSubmissions,
      updateStaffRequirementSubmission,
      deleteStaffRequirementSubmission
    };
    